import { Box, CircularProgress, Typography } from '@mui/material'
import {
  useAcceptInvite,
  useAcceptInviteAuthenticated,
} from '@/api/accounting-dealer'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { routes } from '@/router'
import { clearPendingInvite, savePendingInvite } from '@/helpers'

export function InvitePage() {
  const { deal_user_key } = useParams()

  const navigate = useNavigate()

  const {
    mutate: acceptInvite,
    isPending: acceptingPublic,
    error: publicError,
  } = useAcceptInvite({
    onSuccess: (data) => {
      if ('requires_login' in data) {
        if (deal_user_key) savePendingInvite(deal_user_key)
        navigate(routes.session.signin, { replace: true })
        return
      }

      clearPendingInvite()
      localStorage.setItem('access_token', data.access_token)
      navigate(routes.home)
    },
  })

  const {
    mutate: acceptInviteAuthenticated,
    isPending: acceptingAuthenticated,
    error: authenticatedError,
  } = useAcceptInviteAuthenticated({
    onSuccess: () => {
      clearPendingInvite()
      navigate(routes.home)
    },
    onError: () => clearPendingInvite(),
  })

  useEffect(() => {
    if (!deal_user_key) return

    if (localStorage.getItem('access_token')) {
      acceptInviteAuthenticated(deal_user_key)
      return
    }

    acceptInvite(deal_user_key)
  }, [deal_user_key])

  const isPending = acceptingPublic || acceptingAuthenticated
  const error = publicError || authenticatedError

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      {isPending && (
        <>
          <CircularProgress />
          <Typography mt={2}>
            Aguarde, estamos validando seu convite...
          </Typography>
        </>
      )}
      {error && (
        <Typography color="error" textAlign="center" mt={2}>
          {inviteErrorMessage(error.statusCode, error.message)}
        </Typography>
      )}
    </Box>
  )
}

function inviteErrorMessage(statusCode: number, message: string) {
  if (statusCode === 409) return 'Convite já foi aceito.'
  if (statusCode === 403) {
    return 'Este convite pertence a outra conta. Saia e entre com a conta convidada.'
  }
  return message
}
